import React, { useState, useEffect } from 'react';
import '../styles/Parking.css';
import { translations } from '../data/translations';

const ParkingLanding = () => {
  const [currentLang, setCurrentLang] = useState('en');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const t = (key) => {
    return translations[currentLang]?.[key] || key;
  };

  useEffect(() => {
    document.title = t('page_title');
  }, [currentLang]);

  const handleLanguageChange = (e) => {
    setCurrentLang(e.target.value);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleFormSubmit = (e) => {
    const websiteField = document.getElementById('website');
    if (websiteField && websiteField.value !== '') {
      e.preventDefault();
      alert('Form submission blocked - bot detected');
      return false;
    }
  };

  return (
    <div className="parking-page">
      {/* Header */}
      <header className="parking-header">
        <nav className="parking-nav-wrapper">
          <div className="parking-logo" onClick={() => window.location.href='https://0gbaltics.com'}>
            E2 Parking
          </div>
          
          <ul className={`parking-nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <li><a href="#overview" onClick={closeMobileMenu}>{t('nav_overview')}</a></li>
            <li><a href="#benefits" onClick={closeMobileMenu}>{t('nav_benefits')}</a></li>
            <li><a href="#features" onClick={closeMobileMenu}>{t('nav_features')}</a></li>
            <li><a href="#tech" onClick={closeMobileMenu}>{t('nav_tech')}</a></li>
            <li><a href="#usecases" onClick={closeMobileMenu}>{t('nav_usecases')}</a></li>
            <li><a href="#roi" onClick={closeMobileMenu}>{t('nav_roi')}</a></li>
            <li><a href="#pricing" onClick={closeMobileMenu}>{t('nav_pricing')}</a></li>
            <li><a href="#contact" onClick={closeMobileMenu}>{t('nav_contact')}</a></li>
          </ul>
          
          <select className="parking-language-selector" value={currentLang} onChange={handleLanguageChange}>
            <option value="en">EN</option>
            <option value="fr">FR</option>
            <option value="de">DE</option>
            <option value="lt">LT</option>
            <option value="lv">LV</option>
          </select>
          
          <button className="parking-mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="parking-hero" id="overview">
        <div className="parking-hero-container">
          <div className="parking-hero-content">
            <h1>{t('hero_title')}</h1>
            <p>{t('hero_subtitle')}</p>
            <a href="#contact" className="parking-cta-button">{t('hero_cta')}</a>
          </div>
          <div className="parking-hero-image">
            <img src="/assets/Pic1.jpg" alt="Smart Parking Solution" onError={(e) => {
              e.target.parentElement.innerHTML = '<div class="parking-image-placeholder" style="height:500px">Parking Image (Pic1.jpg)</div>';
            }} />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="parking-section" id="benefits">
        <div className="parking-section-container">
          <div className="parking-section-header">
            <h2>{t('benefits_title')}</h2>
            <p>{t('benefits_subtitle')}</p>
          </div>
          <div className="parking-cards-grid">
            <div className="parking-card">
              <div className="parking-card-icon">⚡</div>
              <h3>{t('benefit1_title')}</h3>
              <p>{t('benefit1_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">📊</div>
              <h3>{t('benefit2_title')}</h3>
              <p>{t('benefit2_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">🎫</div>
              <h3>{t('benefit3_title')}</h3>
              <p>{t('benefit3_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">💳</div>
              <h3>{t('benefit4_title')}</h3>
              <p>{t('benefit4_desc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="parking-section parking-section-alternate" id="features">
        <div className="parking-section-container">
          <div className="parking-section-header">
            <h2>{t('features_title')}</h2>
            <p>{t('features_subtitle')}</p>
          </div>
          <div className="parking-features-grid">
            <div className="parking-card">
              <div className="parking-card-icon">📡</div>
              <h3>{t('feature1_title')}</h3>
              <p>{t('feature1_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">🚫</div>
              <h3>{t('feature2_title')}</h3>
              <p>{t('feature2_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">🏢</div>
              <h3>{t('feature3_title')}</h3>
              <p>{t('feature3_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">💻</div>
              <h3>{t('feature4_title')}</h3>
              <p>{t('feature4_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">🔌</div>
              <h3>{t('feature5_title')}</h3>
              <p>{t('feature5_desc')}</p>
            </div>
            <div className="parking-card">
              <div className="parking-card-icon">📈</div>
              <h3>{t('feature6_title')}</h3>
              <p>{t('feature6_desc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology & Installation Section */}
      <section className="parking-section" id="tech">
        <div className="parking-section-container">
          <div className="parking-tech-content">
            <div className="parking-tech-image">
              <img src="/assets/Pic2.jpg" alt="Installation Diagram" onError={(e) => {
                e.target.parentElement.innerHTML = '<div class="parking-image-placeholder" style="height:400px">Installation Diagram (Pic2.jpg)</div>';
              }} />
            </div>
            <div className="parking-tech-text">
              <h3>{t('tech_title')}</h3>
              <p>{t('tech_desc')}</p>
              <ul className="parking-tech-list">
                <li>{t('tech_list1')}</li>
                <li>{t('tech_list2')}</li>
                <li>{t('tech_list3')}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="parking-section parking-section-alternate" id="usecases">
        <div className="parking-section-container">
          <div className="parking-section-header">
            <h2>{t('usecases_title')}</h2>
          </div>
          <div className="parking-usecases-grid">
            <div className="parking-usecase-card">
              <div className="parking-usecase-image">
                <img src="/assets/Pic3.jpg" alt="Cities & Public Parking" onError={(e) => {
                  e.target.parentElement.innerHTML = '<div class="parking-image-placeholder" style="height:250px">City Parking (Pic3.jpg)</div>';
                }} />
              </div>
              <div className="parking-usecase-content">
                <h3>{t('usecase1_title')}</h3>
                <p>{t('usecase1_desc')}</p>
              </div>
            </div>
            <div className="parking-usecase-card">
              <div className="parking-usecase-image">
                <img src="/assets/Pic4.jpg" alt="Enterprises & Campuses" onError={(e) => {
                  e.target.parentElement.innerHTML = '<div class="parking-image-placeholder" style="height:250px">Campus Parking (Pic4.jpg)</div>';
                }} />
              </div>
              <div className="parking-usecase-content">
                <h3>{t('usecase2_title')}</h3>
                <p>{t('usecase2_desc')}</p>
              </div>
            </div>
            <div className="parking-usecase-card">
              <div className="parking-usecase-image">
                <img src="/assets/Pic5.jpg" alt="Shopping Centers & Hospitals" onError={(e) => {
                  e.target.parentElement.innerHTML = '<div class="parking-image-placeholder" style="height:250px">Commercial Parking (Pic5.jpg)</div>';
                }} />
              </div>
              <div className="parking-usecase-content">
                <h3>{t('usecase3_title')}</h3>
                <p>{t('usecase3_desc')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ROI Section */}
      <section className="parking-section" id="roi">
        <div className="parking-section-container">
          <div className="parking-section-header">
            <h2>{t('roi_title')}</h2>
            <p>{t('roi_subtitle')}</p>
          </div>
          <div className="parking-roi-stats">
            <div className="parking-stat-card">
              <div className="parking-stat-value">{t('roi1_value')}</div>
              <div className="parking-stat-label">{t('roi1_label')}</div>
            </div>
            <div className="parking-stat-card">
              <div className="parking-stat-value">{t('roi2_value')}</div>
              <div className="parking-stat-label">{t('roi2_label')}</div>
            </div>
            <div className="parking-stat-card">
              <div className="parking-stat-value">{t('roi3_value')}</div>
              <div className="parking-stat-label">{t('roi3_label')}</div>
            </div>
            <div className="parking-stat-card">
              <div className="parking-stat-value">{t('roi4_value')}</div>
              <div className="parking-stat-label">{t('roi4_label')}</div>
            </div>
          </div>
          <p className="parking-roi-note">{t('roi_note')}</p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="parking-section parking-section-alternate" id="pricing">
        <div className="parking-section-container">
          <div className="parking-section-header">
            <h2>{t('pricing_title')}</h2>
            <p>{t('pricing_subtitle')}</p>
          </div>
          <div className="parking-pricing-grid">
            <div className="parking-pricing-card">
              <h3>{t('plan1_title')}</h3>
              <p>{t('plan1_desc')}</p>
              <a href="#contact" className="parking-cta-button">{t('pricing_cta')}</a>
            </div>
            <div className="parking-pricing-card parking-featured">
              <h3>{t('plan2_title')}</h3>
              <p>{t('plan2_desc')}</p>
              <a href="#contact" className="parking-cta-button">{t('pricing_cta')}</a>
            </div>
            <div className="parking-pricing-card">
              <h3>{t('plan3_title')}</h3>
              <p>{t('plan3_desc')}</p>
              <a href="#contact" className="parking-cta-button">{t('pricing_cta')}</a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="parking-section" id="contact">
        <div className="parking-section-container">
          <div className="parking-contact-container">
            <div className="parking-section-header">
              <h2>{t('contact_title')}</h2>
              <p>{t('contact_subtitle')}</p>
            </div>
            <form className="parking-contact-form" action="mailto:info@0gbaltics.com" method="post" encType="text/plain" onSubmit={handleFormSubmit}>
              <div className="parking-form-group">
                <label htmlFor="name">{t('contact_name')}</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="parking-form-group">
                <label htmlFor="email">{t('contact_email')}</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="parking-form-group">
                <label htmlFor="phone">{t('contact_phone')}</label>
                <input type="tel" id="phone" name="phone" />
              </div>
              <div className="parking-form-group">
                <label htmlFor="company">{t('contact_company')}</label>
                <input type="text" id="company" name="company" />
              </div>
              <div className="parking-form-group">
                <label htmlFor="message">{t('contact_message')}</label>
                <textarea id="message" name="message" required></textarea>
              </div>
              <div className="parking-form-group parking-hidden">
                <input type="text" id="website" name="website" tabIndex="-1" autoComplete="off" />
              </div>
              <button type="submit" className="parking-cta-button">{t('contact_submit')}</button>
              <p className="parking-form-note">{t('contact_note')}</p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="parking-footer">
        <div className="parking-footer-container">
          <div className="parking-footer-grid">
            <div className="parking-footer-column">
              <h4>{t('footer_lithuania')}</h4>
              <p>E2 Technologies OU<br />Vilnius, Lithuania</p>
            </div>
            <div className="parking-footer-column">
              <h4>{t('footer_latvia')}</h4>
              <p>0g Baltics<br />Riga, Latvia</p>
            </div>
            <div className="parking-footer-column">
              <h4>{t('footer_email')}</h4>
              <p>info@0gbaltics.com</p>
            </div>
          </div>
          <div className="parking-footer-bottom">
            <p>{t('footer_copyright')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ParkingLanding;